import { CardGeneric } from 'components/CardGeneric';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import { Txt } from 'components/Txt';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { View } from 'react-native';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { selectAssetErrors } from 'store/error/selectors';

import { SyncErrorsAsset } from './SyncErrorsAsset';

export const SyncErrorsScreen: React.FC<
  ModalScreenProps<ModalScreens.SYNCERRORS>
> = () => {
  const dispatch = useDispatch();
  const assetErrors = useSelector(selectAssetErrors);

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  return (
    <PageScrollView
      header={
        <NavigationHeader
          onPressCloseButton={() => dispatch(NAVIGATE_MODAL_BACK())}
          heading="Sync Issues"
        />
      }
    >
      <CardGeneric>
        <Txt>
          The following information couldn&apos;t be uploaded to RiskBase during
          sync. If the issues cannot be resolved, you can delete the
          information.
        </Txt>
      </CardGeneric>
      <View style={{ height: theme.paddingPageVertical / 2 }} />
      {assetErrors &&
        Object.entries(assetErrors).map(([id, value]) => (
          <SyncErrorsAsset key={id} assetError={value} assetId={id} />
        ))}
    </PageScrollView>
  );
};
